module.exports = __webpack_public_path__ + "static/media/schlauch_fertig.675b0a0a.jpg";